import { MessageService } from 'elbuild-ui-lib-core';
import { Component, OnInit, Input } from '@angular/core';
import { Project, ProjectService, CostSummary } from 'toolbandi-ui-lib';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-project-costsummary',
	templateUrl: './project-costsummary.component.html',
	styleUrls: ['./project-costsummary.component.scss']
})
export class ProjectCostsummaryComponent implements OnInit {


	@Input()
	project: Project;
	summary: CostSummary;
	loading: boolean;
	constructor(private projectService: ProjectService, private messageService: MessageService, private translateService: TranslateService) { }

	ngOnInit() {
		this.load();
	}

	load() {
		this.loading = true;
		if (this.project) {
			this.projectService.getCostSummary(this.project.id).subscribe(data => {
				this.summary = data;
				this.loading = false;

			}, error => {
				this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
				this.loading = false;

			});
		}
	}
}
